export function fmtTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } catch {
    return "—";
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return `${fmtDate(iso)} ${fmtTime(iso)}`;
}

const FOUR_HOURS_MS = 4 * 60 * 60 * 1000;

export function isOverstay(v, nowMs) {
  if (v.heure_depart) return false;
  return nowMs - new Date(v.heure_arrivee).getTime() > FOUR_HOURS_MS;
}

export function durationLabel(v, nowMs) {
  const start = new Date(v.heure_arrivee).getTime();
  const end = v.heure_depart ? new Date(v.heure_depart).getTime() : nowMs;
  let mins = Math.max(0, Math.round((end - start) / 60000));
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  return `${m}m`;
}

export function motifLabel(v) {
  if (v.motif === "Autre" && v.motif_autre) return v.motif_autre;
  return v.motif;
}
